import React from "react";
import { getActionTheme } from "./util";
import { RiseUserAction } from "@/types/RiseUserAction";
import { useTranslation } from "react-i18next";

export const ActionProgressBar = ({
  action,
  showDetails = false,
}: {
  action: RiseUserAction;
  showDetails?: boolean;
}) => {
  const theme = getActionTheme(action.actionGroup);
  const doneCount = action.metrics?.doneCount || 0;
  const skippedCount = action.metrics?.skippedCount || 0;
  const notDoneCount = action.metrics?.notDoneCount || 0;
  const completed = doneCount + skippedCount;
  const total = completed + notDoneCount;
  const percent = total > 0 ? completed / total : 0;
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3">
      <div
        className={`${theme?.progressBg} h-2 w-[187px] overflow-hidden rounded`}
      >
        <div
          className={`${theme?.progress} h-full`}
          style={{ width: `${percent * 100}%` }}
        ></div>
      </div>
      {showDetails ? (
        <div className="flex items-center gap-1 text-xs font-[500] text-muted-foreground">
          <div>
            {t("strategyBoard.actions.notDone", { count: notDoneCount })}
          </div>
          <DotSeparater />
          <div>{t("strategyBoard.actions.done", { count: doneCount })}</div>
          <DotSeparater />
          <div>
            {t("strategyBoard.actions.skipped", { count: skippedCount })}
          </div>
          <DotSeparater />
          <div>{t("strategyBoard.actions.total", { count: total })}</div>
        </div>
      ) : (
        <div className="flex text-xs font-[500] text-muted-foreground">
          {t("strategyBoard.actions.remaining", { count: notDoneCount })}
        </div>
      )}
    </div>
  );
};

const DotSeparater = () => "·";
